import './DetailsSidebar.scss';
import { Sidebar } from "primereact/sidebar";
import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';
import LoadingOverlay from '../loadingoverlay/LoadingOverlay';


const DetailsSidebar = ({title, contentKey, onSave, onCancel, className,children, isLoading, isSaving, 
    renderTitlePrefix = null, showSaveButton = true, showCancelButton = true, autoComplete = true, ...rest}) => {

    const { t } = useTranslation();

    const handleSave = () => {
        if (onSave) {
            onSave();
        }
    }

    const handleClose = () => {
        rest?.onHide();
    }

    const handleShow = () => {
        if (rest?.onShow && typeof rest.onShow === 'function') {
            rest.onShow();
        }
    }
    
    return (
        
            <Sidebar {...rest} position="right" className={`details-sidebar ${className}`} onShow={handleShow} onHide={handleClose} dismissable={false}>
                <LoadingOverlay loading={isLoading}>                
                    <div className="details-sidebar-content" id="details-sidebar-content" key={contentKey}>
                        <div className="details-sidebar-header">
                            {renderTitlePrefix && renderTitlePrefix()}
                            <h2>{title}</h2>
                        </div>
                        <div className="details-sidebar-form" id="details-sidebar-form">
                            <form autoComplete={autoComplete ? 'on' : 'off'} onSubmit={(e) => e.preventDefault()}>
                                {children}
                            </form>
                        </div>
                        <div className="details-sidebar-footer">
                            {showSaveButton &&<Button label={t('detailsSidebar.save')} className='w-full' onClick={handleSave} loading={isSaving} type="button" />}
                            {showCancelButton && <Button label={t('detailsSidebar.cancel')} className="w-full p-button-secondary" onClick={handleClose} type="button" />}
                        </div>
                    </div>                
                </LoadingOverlay>
            </Sidebar>
        // </form>
    )
}

export default DetailsSidebar;